import { useMemo } from 'react';
import { useTrack } from '@hotjar/webapp/hooks/useTrack';

const GUIDE_CARD_UI_POSITION = 'Space Guide Card';

export function useGuideCardTrack(): { click: (elementName: string) => void } {
  const { click: trackClick } = useTrack();

  return useMemo(
    () => ({
      click: (elementName: string) => trackClick(elementName, GUIDE_CARD_UI_POSITION, {}),
    }),
    [trackClick],
  );
}
